import type { GameModule } from '@arcraz/arcadia-types';
import cityHop from './city-hop/index.js';
import demo from './demo/index.js';
import interceptor from './interceptor/index.js';
import neonOverpass from './neon-overpass/index.js';
import stardust from './stardust/index.js';

/**
 * The cartridge catalog. Each entry is a `GameModule` per
 * `@arcraz/arcadia-types`. The cabinet's selector (sc-2818) reads this
 * list to render the vertical tile stack.
 *
 * Order is curated, not alphabetical — it's the marquee lineup.
 * DEMO will be removed once enough real cartridges exist; keeping it for
 * now as the cabinet's "smallest valid GameModule" sanity check.
 */
export const CARTRIDGES: readonly GameModule[] = [neonOverpass, interceptor, stardust, cityHop, demo];
